/**
 * Nome do registro no último item da trilha (DEMO-03: "Clientes › Grupo Alfaluz",
 * "Oportunidades › #0512"). A tela, depois de carregar, informa o nome; até lá
 * a trilha mostra o rótulo genérico ("Cliente", "Oportunidade"…).
 */
import { createContext, useContext, useEffect } from 'react';

/** Recebe um texto (último item) ou uma lista (os últimos itens, na ordem). */
export const ContextoTrilha = createContext<((textos: string[]) => void) | null>(null);

export function useRotuloTrilha(texto: string | string[] | null | undefined) {
  const definir = useContext(ContextoTrilha);
  const chave = Array.isArray(texto) ? texto.join('\u0000') : (texto ?? '');
  useEffect(() => {
    if (chave) definir?.(chave.split('\u0000'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [definir, chave]);
}
